module.exports = "<daily-report mode=\"'create'\"></daily-report>"


//////////////////
// WEBPACK FOOTER
// ./client/app/dailyReport/index.pug
// module id = 239
// module chunks = 0